import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const ChatContext = createContext(null);

export function ChatProvider({ children }) {
  const [chatMessages, setChatMessages] = useState([]);
  const [conversationId, setConversationId] = useState(() => `home-${Date.now()}`);
  // Lane 1439: the conversation that is current NOW, shared by every Home instance. A
  // Home that unmounted with a chat turn still in flight checks this (not its own last
  // render) before writing the answer, so a turn sent before "Start a new chat" never
  // lands in the new chat. With that button off the id never changes, so this always
  // equals the one id, as before.
  const liveConversationRef = useRef(conversationId);
  liveConversationRef.current = conversationId;

  const clearChat = useCallback(() => {
    setChatMessages([]);
  }, []);

  // Lane 1439: "Start a new chat" on the RFP card (version 2 only). The same fresh
  // chat a page reload gives: no messages and a new conversation id. Home is keyed
  // on the id, so every per-chat state on the page starts again too. Nothing else
  // calls it, so with that card off the id never changes.
  const startNewChat = useCallback(() => {
    let next = `home-${Date.now()}`;
    if (next === liveConversationRef.current) next = `${next}-1`;
    liveConversationRef.current = next;
    setChatMessages([]);
    setConversationId(next);
  }, []);

  return (
    <ChatContext.Provider value={{ chatMessages, setChatMessages, conversationId, clearChat, startNewChat, liveConversationRef }}>
      {children}
    </ChatContext.Provider>
  );
}

export function useChatContext() {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChatContext must be used within a ChatProvider');
  }
  return context;
}

export default ChatContext;
